import { useEffect, useState } from "react";
import { useAuth } from "@bca-auth0/bca-auth0-provider";
import getLolAccount from "../../src/api/getLolAccount";

export function useGetLolAccount(isToUseAuthZero: boolean) {
  const { accessToken, isAuthenticated } = useAuth(!isToUseAuthZero);
  const [isLolVendor, setIsLolVendor] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!isToUseAuthZero) {
      setIsLoading(false);
      return;
    }

    if (!isAuthenticated || !accessToken) {
      return;
    }

    let cancelled = false;

    const fetchLolAccount = async () => {
      setIsLoading(true);
      try {
        const result = await getLolAccount(accessToken);
        if (!cancelled) {
          setIsLolVendor(result?.isLiveOnlineVendor ?? false);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err);
          setIsLolVendor(false);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    fetchLolAccount();

    return () => {
      cancelled = true;
    };
  }, [isToUseAuthZero, isAuthenticated, accessToken]);

  return { isLolVendor, isLoading, error };
}
